import React, { useState, useEffect } from "react";
import Left from "./Left";
import { AppProvider, useAppContext } from "@/AppContext";
import { ReactFlowProvider } from "@xyflow/react";
import PageTop from "../PageTop";
import PageSeletor from "@/Pages/Project/Flow/Right/PageSeleltor";
import { useLocation, useParams } from "react-router-dom";

const Component = () => {
  // const { state, actions } = useAppContext();
  // const location = useLocation();
  // const params = useParams();

  // useEffect(() => {
  //   // 解析URL参数并更新状态
  //   const { k: projectId, f: flowId } = params;
  //   const searchParams = new URLSearchParams(location.search);
  //   const taskId = searchParams.get("j");

  //   console.log("Flow组件路由参数:", { projectId, flowId, taskId });

  //   actions.loadData();
  //   // 执行数据加载逻辑
  // }, [params, location.search]);

  return (

    <ReactFlowProvider>
      <>
        <PageTop
          mainContent={
            <div className="settingSelectorArea">
              <PageSeletor />
            </div>
          }
          extra={
            <div style={{ marginRight: "20px" }}>

            </div>
          }
        />


        <div className="mainContent">
          <div>流程页面展示</div>
          {/* <Left
            cartItems={cartItems}
            setCartItems={setCartItems}
            isAdded={isAdded}
            setIsAdded={setIsAdded}
          /> */}
          {/* <Right /> */}
        </div>
      </>
    </ReactFlowProvider>
  );
};

export default Component;
